/**
 * エラーコードの定数定義
 */
export const ErrorCodeConstants = {
  // エラーコード一覧(4桁目'7'とする)
  ERROR_CODES: {
    EAPZ000001: 'EAP7000001',
    EAPZ000003: 'EAP7000003',
    EAPZ000004: 'EAP7000004',
    EAPZ000009: 'EAP7000009',
    EAPZ000010: 'EAP7000010',
    EAPZ000018: 'EAP7000018',
    EAPZ000019: 'EAP7000019',
    EAPZ000020: 'EAP7000020',
    EAPZ000050: 'EAP7000050',
    EAPZ000051: 'EAP7000051',
    EBAA000002: 'EBA7100002',
    EBAA000003: 'EBA7100003',
    EBAA000017: 'EBA7100017',
    EBAZ000004: 'EBA7000004',
    EBAZ000005: 'EBA7000005',
    EBAZ000006: 'EBA7000006',
    EBAZ000007: 'EBA7000007',
    EBAZ000008: 'EBA7000008',
    EBAZ000009: 'EBA7000009',
    EBAZ000010: 'EBA7000010',
    EBAZ000011: 'EBA7000011',
    EBAZ000012: 'EBA7000012',
    EBAZ000013: 'EBA7000013',
    EBAZ000015: 'EBA7000015',
    EBAZ000104: 'EBA7000104',
    EBAZ000109: 'EBA7000109',
    EBAZ000111: 'EBA7000111',
    EBAZ000112: 'EBA7000112',
    EBAZ000113: 'EBA7000113',
    EBAZ000114: 'EBA7000114',
    EBAZ000115: 'EBA7000115',
    EBAZ000116: 'EBA7000116',
    EBAZ000117: 'EBA7000117',
    EBAZ000119: 'EBA7000119',
    EBAZ000120: 'EBA7000120',
    EBAZ000121: 'EBA7000121',
    EBAZ000122: 'EBA7000122',
    EBAZ000123: 'EBA7000123',
    EBAZ000124: 'EBA7000124',
    EBAZ000126: 'EBA7000126',
    EBAZ000127: 'EBA7000127',
    EBAZ000128: 'EBA7000128',
    EBAZ000293: 'EBA7000293',
    EBAZ000294: 'EBA7000294',
    EBAZ000319: 'EBA7000319',
    EBAZ000322: 'EBA7000322',
    EBAZ000349: 'EBA7000349',
    EBAZ000350: 'EBA7000350',
    EBAZ000351: 'EBA7000351',
    EBAZ000353: 'EBA7000353',
    EBAZ000355: 'EBA7000355',
    EBAZ000357: 'EBA7000357',
    EBAZ000358: 'EBA7000358',
    EBAZ000359: 'EBA7000359',
    EBAZ000363: 'EBA7000363',
    EBAZ000364: 'EBA7000364',
    EBAZ000379: 'EBA7000379',
    EBAZ000397: 'EBA7000397',
    EBAZ000398: 'EBA7000398',
    EBAZ000399: 'EBA7000399',
    EBAZ000496: 'EBA7000496',
    EBAZ000619: 'EBA7000619',
    EBAZ000644: 'EBA7000644',
    EBAZ000645: 'EBA7000645',
    EBAZ000647: 'EBA7000647',
    EBAZ000656: 'EBA7000656',
    EBAZ000721: 'EBA7000721',
    EBAZ000723: 'EBA7000723',
    EBAZ000731: 'EBA7000731',
    EBAZ000732: 'EBA7000732',
    EBAZ000733: 'EBA7000733',
    EBAZ000734: 'EBA7000734',
    EBAZ000774: 'EBA7000774',
    EBAZ000776: 'EBA7000776',
    EBAZ000781: 'EBA7000781',
    EBAZ000811: 'EBA7000811',
    EBAZ000812: 'EBA7000812',
    EBAZ000814: 'EBA7000814',
    EBAZ000816: 'EBA7000816',
    EBAZ000818: 'EBA7000818',
    EBAZ000819: 'EBA7000819',
    EBAZ000823: 'EBA7000823',
    EBAZ000892: 'EBA7000892',
    EBAZ000909: 'EBA7000909',
    EBAZ000999: 'EBA7000999',
    EIFA000001: 'EIF7100001',
    EIFA000002: 'EIF7100002',
    EIFA000003: 'EIF7100003',
    EIFA000004: 'EIF7100004',
    EIFA000005: 'EIF7100005',
    EIFA000006: 'EIF7100006',
    EIFA000007: 'EIF7100007',
    EIFA000008: 'EIF7100008',
    EIFA000009: 'EIF7100009',
    EIFA000011: 'EIF7100011',
    EIFA000012: 'EIF7100012',
    EIFA000013: 'EIF7100013',
    FDXZ000005: 'FDX7000005',
    FIFA000001: 'FIF7100001',
  },
};

/**
 * ワーニングコードの定数定義
 */
export const WarningCodeConstants = {
  // ワーニングコード一覧(4桁目'7'とする)
  WARNING_CODES: {
    WBAZ000046: 'WBA7000046',
    WBAZ000047: 'WBA7000047',
    WBAZ000247: 'WBA7000247',
    WBAZ000252: 'WBA7000252',
    WBAZ000255: 'WBA7000255',
    WBAZ000570: 'WBA7000570',
    WBAZ000578: 'WBA7000578',
    WBAZ000579: 'WBA7000579',
    WBAZ000580: 'WBA7000580',
    WBAZ000581: 'WBA7000581',
    WBAZ000582: 'WBA7000582',
  },
};

/**
 * 共通処理で利用する定数の定義
 */
export const CommonConstants = {
  THREE_LETTER: 'SFJ',
  TWO_LETTER: '7G',
  // オフィスコードチェック用定数
  OFFICE_CODE_JP: 'KKJ7G08', // 日本統合オフィスコード
  OFFICE_CODE_JP_R: 'KKJ7G08AA', // 有償日本オフィス
  OFFICE_CODE_JP_R_APF: '', // 有償日本オフィスAPF
  OFFICE_CODE_JP_A: 'KKJ7G08ZZ', // 特典日本オフィス
  // 提携3社ログインモーダルで(ADO,SFJ,SNJ)会員番号チェック用定数
  MEMBER_NUMBER_RULES: {
    type: 'numberic' as 'alphaNumberic' | 'numberic',
    length: 10,
  },
  // ログインモーダルのパスワードチェック用定数
  PASSWORD_RULES: {
    minPwLength: 8,
    maxPwLength: 16,
    pwRegex: '^[a-zA-Z0-9-_.+$#!/@(%&*?)]*$',
  },
  // ログイン情報連携機能が有効か
  LOGIN_INFO_INTEGRATION_ENABLED: false,
  // 提携社サイトに戻る際のURL切り替え機能が有効か
  RETURN_URL_SWITCH_ENABLED: false,
  LOGO_FILE_PATH: 'assets/images/logo_sfj.svg',
  LOGO_S_FILE_PATH: 'assets/images/logo_sfj_s.svg',
  // 法人ヘッダー用ロゴファイルパス
  LOGO_BIZ_FILE_PATH: 'assets/images/logo_sfj_black.svg',
  // ログインAPIエラーコードMAP
  LOGIN_API_ERROR_MAP: {
    [ErrorCodeConstants.ERROR_CODES.EIFA000001]: 'EA021', // ログイン情報なし
    [ErrorCodeConstants.ERROR_CODES.EIFA000002]: 'EA022', // ログイン情報が無効
    [ErrorCodeConstants.ERROR_CODES.EIFA000003]: 'EA014', // 一定時間内のログイン試行回数超過によりブロックされた会員
    [ErrorCodeConstants.ERROR_CODES.EIFA000004]: 'EA020', // パスワード不一致
    [ErrorCodeConstants.ERROR_CODES.EIFA000005]: 'EA013', // パスワード有効期限切れ
    [ErrorCodeConstants.ERROR_CODES.EIFA000006]: 'EA016',
    [ErrorCodeConstants.ERROR_CODES.EIFA000007]: 'EA023',
    [ErrorCodeConstants.ERROR_CODES.EIFA000008]: 'EA024',
    [ErrorCodeConstants.ERROR_CODES.EIFA000009]: 'EA017',
    [ErrorCodeConstants.ERROR_CODES.EIFA000011]: 'EA015',
    [ErrorCodeConstants.ERROR_CODES.EIFA000012]: 'EA018',
    [ErrorCodeConstants.ERROR_CODES.EIFA000013]: 'EA025',
    [ErrorCodeConstants.ERROR_CODES.EBAA000002]: 'EA050', // 会員区分が無効会員の場合
    [ErrorCodeConstants.ERROR_CODES.EBAA000003]: 'EA051', // 認証結果がfalse
    [ErrorCodeConstants.ERROR_CODES.EBAA000017]: 'EA027', // 会員情報がダミー値
    [ErrorCodeConstants.ERROR_CODES.EAPZ000009]: 'E0361', // 搭乗者に含まれているかチェック
    [ErrorCodeConstants.ERROR_CODES.EAPZ000010]: 'E0361', // マイル減算者の会員かチェックエラー
    [ErrorCodeConstants.ERROR_CODES.FIFA000001]: 'EA019', // ifly接続エラー(想定外エラー)
  } as { [key: string]: string },
  // InlineTelemetry付与対象URL
  INLINETELEMETRY_URL: {
    AUTH_LOGIN: {
      ENDPOINT: /\/all-.*-member\/api\/.*\/auth-login/,
      METHOD: 'POST',
    },
    PAYMENT_RECORD: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/orders\/payment-records/,
      METHOD: 'POST',
    },
    CREATE_ORDER: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/orders\/create-order/,
      METHOD: 'POST',
    },
    CAPTCHA_AUTHENTICATION: {
      ENDPOINT: /\/all-.*-search\/api\/.*\/captcha-authentication$/,
      METHOD: 'POST',
    },
    CREATE_CART: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/carts\/create-cart/,
      METHOD: 'POST',
    },
    ROUNDTRIP_FPP: {
      ENDPOINT: /\/all-.*-search\/api\/.*\/roundtrip-fpp/,
      METHOD: 'POST',
    },
  } as { [key: string]: { ENDPOINT: RegExp; METHOD: string } },
} as const;

/**
 * APP内で利用する定数の定義
 */
export const AppConstants = {
  IMG: {
    // 全体
    ALL_EXTERNAL_PRIMARY: 'assets/images/icon_external_sfj_blue_16.svg',
    ALL_EXTERNAL_RED: 'assets/images/icon_external_sfj_red_dark_16.svg',
    ALL_HELP_PRIMARY: 'assets/images/icon_help_sfj_red_dark_24.svg',
    ALL_CHECKINSTATUS_NOTACCEPTED: 'assets/images/icon_remove_20.svg',
    ALL_CHECKINSTATUS_ACCEPTED: 'assets/images/icon_feature_available_sfj_blue_24.svg',
    // C01-P040-S01-U チェックインシートマップ
    C01_P040_S01_U_SEATMAP_FLOAT_LEGEND: 'assets/images/seatmap_float_legend_sfj.svg',
    C01_P040_S01_U_SEATMAP_FLOAT_SEATTYPE: 'assets/images/seatmap_float_seattype_sfj.svg',
    C01_P040_S01_U_LEGENDS_SEAT_SELECTED: 'assets/images/seat_selected_sfj_24.svg',
    C01_P040_S01_U_LEGENDS_SEAT_BEFORE_CHANGE_FREE_SEAT: 'assets/images/seat_before_change_free_seat_sfj_24.svg',
    C01_P040_S01_U_LEGENDS_EMERGENCY_EXIT_SEAT: 'assets/images/seat_emergency_exit_seat_sfj_24.svg',
    C01_P040_S01_U_LEGENDS_SEAT_LAVATORY: 'assets/images/seat_lavatory_sfj_24.svg',
    C01_P040_S01_U_LEGENDS_GALLEY: 'assets/images/seat_galley_sfj_24.svg',
    C01_P040_S01_U_LEGENDS_WING: 'assets/images/seat_wing_sfj_24.svg',
  },
  ABLE_D_TRANSITION_PARAMETER: {
    EXTERNAL_FLG: 'NEWSFJ',
    ALLIANCE_FLG: 'SFJ',
  },
} as const;
